import { render, staticRenderFns } from "./ExResponsibilityModal.vue?vue&type=template&id=2e1c7098"
import script from "./ExResponsibilityModal.vue?vue&type=script&lang=js"
export * from "./ExResponsibilityModal.vue?vue&type=script&lang=js"
import style0 from "./ExResponsibilityModal.vue?vue&type=style&index=0&id=2e1c7098&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports